// actionButton — when A7 populated `target` on the spec, treat it as either:
//   • a page-folder name (starts with "ReportSection") → react-router navigate to /p/{target}
//   • a bookmark name (starts with "Bookmark") → write a "bookmark" key into the filter store
// If neither, fall back to a no-op (log only).

import { useNavigate } from "react-router-dom";
import type { VisualProps } from "./types";
import { useFilterStore } from "../state/filterStore";
import "./_static.css";

export function ActionButtonVisual({ spec }: VisualProps) {
  const navigate = useNavigate();
  const addFilter = useFilterStore((s) => s.addFilter);
  const label = spec.text ?? spec.title ?? "Action";
  const target = spec.target ?? null;

  const onClick = () => {
    if (!target) {
      return;
    }
    if (target.startsWith("ReportSection")) {
      navigate(`/p/${encodeURIComponent(target)}`);
      return;
    }
    if (target.startsWith("Bookmark") || /^[a-f0-9]{20}$/i.test(target)) {
      // Bookmark target — record the active bookmark in the filter store so the
      // BookmarkNavigatorVisual can reflect it.
      addFilter("bookmark", { op: "eq", value: target, source: spec.id });
      return;
    }
    // Unhandled target — fall through to no-op.
  };

  return (
    <button
      type="button"
      className="static-action-button"
      onClick={onClick}
      title={target ?? undefined}
    >
      {spec.icon && <span className="static-action-icon">→</span>}
      <span>{label}</span>
    </button>
  );
}
